import { http } from '../rest';

export function fetchDocuments(http, demo) {
  return {
    async execute(clientId) {
      let data;
      if (demo) {
        const file = await import('./fetchDocuments.data');
        data = file.default;
      } else {
        const response = await http.get(`/clients/${clientId}/documents_and_accounts`);
        data = response.data;
      }
      return data;
    },
  };
}

export default fetchDocuments(http, process.env.DEMO);
